import React from 'react'
import { IonPage } from '@ionic/react'
// import logo from "../../../assets/logos/logo_osde.svg"
import { OsdeWhite } from "app-principal-componentes-visuales";
import './SplashScreen.scss'

const SplashScreen = () => {
  return (
    <IonPage>
      <div className="loading-screen">
        <div className='logo'>
          <OsdeWhite />
        </div>
      </div>
    </IonPage>
  )
}

export default SplashScreen